import React, { useState } from "react";
import axios from "axios";
import CONFIG from "./config";
import CustomAlert from "./CustomAlert";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import "./AddbBlogform.css";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaTimes } from "react-icons/fa";

const AddBlogForm = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [newBioData, setNewBioData] = useState({
    imagePath: "",
    image: null,
    organizationName: "",
    memberName: "",
    designation: "",
    address: "",
    experiance: "",
  });

  const [alert, setAlert] = useState(null);

  const [energyFields, setEnergyFields] = useState([
    {
      energyTitle: "",
      energySubTitle: "",
      energyDescription: "",
      additionalFields: [],
    },
  ]);

  const [imagePreview, setImagePreview] = useState(
    newBioData.imagePath ? newBioData.imagePath : ""
  );

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "image" && files && files.length > 0) {
      const file = files[0];
      setImagePreview(URL.createObjectURL(file));
      setNewBioData({ ...newBioData, image: file });
    } else {
      setNewBioData({ ...newBioData, [name]: value });

      if (name === "imagePath" && !files) {
        setImagePreview(`${value.startsWith("/") ? value : `/${value}`}`);
      }
    }
  };

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const updatedFields = [...energyFields];
    updatedFields[index][name] = value;
    setEnergyFields(updatedFields);
  };

  const addAdditionalField = (sectionIndex, type) => {
    const updatedFields = [...energyFields];
    const newField = {
      type: type,
      value: type === "list" ? [""] : "", // Initialize with one empty string for list
      ...(type === "link" ? { linkText: "", linkURL: "" } : {}),
      ...(type === "web-link" ? { webLinkText: "", webLinkURL: "" } : {}),
      id: Date.now(),
    };
    updatedFields[sectionIndex].additionalFields.push(newField);
    setEnergyFields(updatedFields);
  };

  const handleAdditionalFieldChange = (sectionIndex, fieldIndex, e) => {
    const { name, value } = e.target;
    const updatedFields = [...energyFields];
    const field = updatedFields[sectionIndex].additionalFields[fieldIndex];

    if (field.type === "link") {
      field[name] = value;
    } else {
      field.value = value;
    }
    if (field.type === "web-link") {
      field[name] = value;
    } else {
      field.value = value;
    }

    setEnergyFields(updatedFields);
  };

  const handleLinkChange = (sectionIndex, fieldIndex, e) => {
    const { name, value } = e.target;
    const updatedFields = [...energyFields];
    const field = updatedFields[sectionIndex].additionalFields[fieldIndex];
    field[name] = value;
    setEnergyFields(updatedFields);
  };

  const addFields = () => {
    setEnergyFields([
      ...energyFields,
      {
        energyTitle: "",
        energySubTitle: "",
        energyDescription: "",
        additionalFields: [],
      },
    ]);
  };

  const handleListItemChange = (sectionIndex, fieldIndex, itemIndex, e) => {
    const { value } = e.target;
    const updatedFields = [...energyFields];
    updatedFields[sectionIndex].additionalFields[fieldIndex].value[itemIndex] =
      value;
    setEnergyFields(updatedFields);
  };

  const addListItem = (sectionIndex, fieldIndex) => {
    const updatedFields = [...energyFields];
    updatedFields[sectionIndex].additionalFields[fieldIndex].value.push("");
    setEnergyFields(updatedFields);
  };

  const removeListItem = (sectionIndex, fieldIndex, itemIndex) => {
    const updatedFields = [...energyFields];
    updatedFields[sectionIndex].additionalFields[fieldIndex].value.splice(
      itemIndex,
      1
    );
    setEnergyFields(updatedFields);
  };

  const removeEnergyField = (index) => {
    const updatedFields = energyFields.filter((_, i) => i !== index);
    setEnergyFields(updatedFields);
  };

  const removeAdditionalField = (sectionIndex, fieldIndex) => {
    const updatedFields = [...energyFields];
    updatedFields[sectionIndex].additionalFields.splice(fieldIndex, 1);
    setEnergyFields(updatedFields);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("image", newBioData.image);
    formData.append("organizationName", newBioData.organizationName);
    formData.append("memberName", newBioData.memberName);
    formData.append("designation", newBioData.designation);
    formData.append("address", newBioData.address);
    formData.append("experiance", newBioData.experiance);

    energyFields.forEach((field, index) => {
      formData.append(`energyFields[${index}][energyTitle]`, field.energyTitle);
      formData.append(
        `energyFields[${index}][energySubTitle]`,
        field.energySubTitle
      );
      formData.append(
        `energyFields[${index}][energyDescription]`,
        field.energyDescription
      );

      field.additionalFields.forEach((additionalField, fieldIndex) => {
        formData.append(
          `energyFields[${index}][additionalFields][${fieldIndex}][type]`,
          additionalField.type
        );

        if (additionalField.type === "list") {
          // Stringify the array for list type
          formData.append(
            `energyFields[${index}][additionalFields][${fieldIndex}][value]`,
            JSON.stringify(additionalField.value)
          );
        } else if (additionalField.type === "link") {
          formData.append(
            `energyFields[${index}][additionalFields][${fieldIndex}][linkText]`,
            additionalField.linkText || ""
          );
          formData.append(
            `energyFields[${index}][additionalFields][${fieldIndex}][linkURL]`,
            additionalField.linkURL || ""
          );
        } else if (additionalField.type === "web-link") {
          formData.append(
            `energyFields[${index}][additionalFields][${fieldIndex}][webLinkText]`,
            additionalField.webLinkText || ""
          );
          formData.append(
            `energyFields[${index}][additionalFields][${fieldIndex}][webLinkURL]`,
            additionalField.webLinkURL || ""
          );
        } else {
          formData.append(
            `energyFields[${index}][additionalFields][${fieldIndex}][value]`,
            additionalField.value || ""
          );
        }
      });
    });

    try {
      await axios.post(`${CONFIG.BASE_URL}/biodata/add`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success("Bio data Added successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setTimeout(() => navigate("/bio-data-table"), 1500);
    } catch (error) {
      toast.error("Error adding bio data", {
        position: "top-right",
        autoClose: 3000,
      });
      console.error("Error:", error);
    }
  };

  return (
    <div
      className="modal-overlay boardmember admin_modal_preview wow fadeInUp"
      data-wow-delay="0.2s"
    >
      <div className="custom-modal-content">
        <ToastContainer />
        {alert && (
          <CustomAlert
            message={alert.message}
            onClose={() => setAlert(null)}
            type={alert.type}
          />
        )}

        <form className="m-0" onSubmit={handleSubmit}>
          <h2 className="mt-0 text-center">{"Create Member details"}</h2>

          <div className="col-md-12 d-inline-block bioform">
            <div className="col-md-12 sec_border d-flex ">
              <div className="col-md-6">
                <div className="col-md-12">
                  <div className="custom-form-group mb-1">
                    <label className="custom-label">Member's Name:</label>
                    <input
                      type="text"
                      name="memberName"
                      value={newBioData.memberName}
                      style={{ background: "none", color: "white" }}
                      onChange={handleInputChange}
                      className="custom-input"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="custom-form-group mb-1">
                    <label className="custom-label">Designation:</label>
                    <input
                      type="text"
                      name="designation"
                      value={newBioData.designation}
                      style={{ background: "none", color: "white" }}
                      onChange={handleInputChange}
                      className="custom-input"
                      required
                    />
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="custom-form-group mb-1">
                    <label className="custom-label">Organization Name:</label>
                    <input
                      type="text"
                      name="organizationName"
                      value={newBioData.organizationName}
                      style={{ background: "none", color: "white" }}
                      onChange={handleInputChange}
                      className="custom-input"
                      required
                    />
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="custom-form-group mb-1">
                    <label className="custom-label">address:</label>
                    <input
                      type="text"
                      name="address"
                      value={newBioData.address}
                      style={{ background: "none", color: "white" }}
                      onChange={handleInputChange}
                      className="custom-input"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="custom-form-group mb-1">
                    <label className="custom-label">Experiance:</label>
                    <input
                      type="text"
                      name="experiance"
                      value={newBioData.experiance}
                      style={{ background: "none", color: "white" }}
                      onChange={handleInputChange}
                      className="custom-input"
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="imageadd_section">
                  <div
                    className="user_circleimage"
                    style={{
                      alignItems: "center",
                      padding: "5px",
                      marginBottom: "20px",
                      border: "1px solid",
                    }}
                  >
                    {imagePreview ? (
                      <>
                        {/* Image Preview */}
                        <img src={imagePreview} alt="Preview" width="200" />
                        {/* Delete Button below the Image */}
                        <div className="custom-form-group closeimags">
                          <button
                            type="button"
                            className="btn"
                            onClick={() => {
                              setImagePreview("");
                              setNewBioData({ ...newBioData, image: null });
                            }}
                            style={{
                              display: "inline-block",
                              justifyContent: "center",
                              alignItems: "center",
                              cursor: "pointer",
                              padding: "15px",
                              color: "red",
                            }}
                          >
                            <FaTimes />
                          </button>
                        </div>
                      </>
                    ) : (
                      <div
                        className="upload_imgwrap"
                        style={{ alignItems: "center", background: "#fff" }}
                      >
                        <input
                          id="file-upload"
                          type="file"
                          name="image"
                          accept="image/*"
                          style={{ display: "none" }}
                          onChange={handleInputChange}
                        />
                        <button
                          type="button"
                          className="custom-file-btn m-0 addimgcta"
                          onClick={() =>
                            document.getElementById("file-upload").click()
                          }
                        >
                          Add Image
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 text-center mt-3">
              <h5>Make Member's Journery</h5>
            </div>

            <div className="col-md-12 pt-2">
              {energyFields.map((field, sectionIndex) => (
                <div
                  className="row mb-2"
                  key={sectionIndex}
                  style={{ position: "relative" }}
                >
                  <div className="col-md-6">
                    <div className="custom-form-group">
                      <label className="custom-label">Energy Title:</label>
                      <input
                        type="text"
                        name="energyTitle"
                        value={field.energyTitle}
                        style={{ background: "none", color: "white" }}
                        onChange={(e) => handleChange(sectionIndex, e)}
                        className="custom-input"
                      />
                    </div>
                    <div className="custom-form-group">
                      <label className="custom-label">Energy SubTitle:</label>
                      <input
                        type="text"
                        name="energySubTitle"
                        value={field.energySubTitle}
                        style={{ background: "none", color: "white" }}
                        onChange={(e) => handleChange(sectionIndex, e)}
                        className="custom-input"
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="custom-form-group">
                      <label className="custom-label">
                        Energy Description:
                      </label>
                      <textarea
                        name="energyDescription"
                        value={field.energyDescription}
                        style={{ background: "none", color: "white" }}
                        onChange={(e) => handleChange(sectionIndex, e)}
                        className="custom-textarea"
                      />
                    </div>
                  </div>

                  {/* Additional Fields Section */}
                  {field.additionalFields.map((additionalField, fieldIndex) => (
                    <div
                      className="col-md-12"
                      key={additionalField.id}
                      style={{ position: "relative" }}
                    >
                      {additionalField.type === "paragraph" ? (
                        <div className="custom-form-group">
                          <label className="custom-label">
                            Additional Paragraph:
                          </label>
                          <textarea
                            value={additionalField.value}
                            style={{ background: "none", color: "white" }}
                            onChange={(e) =>
                              handleAdditionalFieldChange(
                                sectionIndex,
                                fieldIndex,
                                e
                              )
                            }
                            className="custom-textarea"
                          />
                        </div>
                      ) : additionalField.type === "text" ? (
                        <div className="custom-form-group">
                          <label className="custom-label">
                            Additional Text:
                          </label>
                          <input
                            type="text"
                            value={additionalField.value}
                            style={{ background: "none", color: "white" }}
                            onChange={(e) =>
                              handleAdditionalFieldChange(
                                sectionIndex,
                                fieldIndex,
                                e
                              )
                            }
                            className="custom-input"
                          />
                        </div>
                      ) : additionalField.type === "list" ? (
                        <div className="custom-form-group">
                          <label className="custom-label">List Items:</label>
                          <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
                            {additionalField.value.map((item, itemIndex) => (
                              <li
                                key={itemIndex}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginBottom: "5px",
                                }}
                              >
                                <input
                                  type="text"
                                  value={item}
                                  style={{
                                    background: "none",
                                    color: "white",
                                    flex: 1,
                                    marginRight: "5px",
                                  }}
                                  onChange={(e) =>
                                    handleListItemChange(
                                      sectionIndex,
                                      fieldIndex,
                                      itemIndex,
                                      e
                                    )
                                  }
                                  className="custom-input"
                                />
                                <button
                                  className="btn btn-danger"
                                  type="button"
                                  onClick={() =>
                                    removeListItem(
                                      sectionIndex,
                                      fieldIndex,
                                      itemIndex
                                    )
                                  }
                                  style={{
                                    background: "transparent",
                                    border: "none",
                                    color: "red",
                                    cursor: "pointer",
                                  }}
                                >
                                  <FaTimes />
                                </button>
                              </li>
                            ))}
                          </ul>
                          <button
                            type="button"
                            onClick={() =>
                              addListItem(sectionIndex, fieldIndex)
                            }
                            className="custom-btn-submit"
                            style={{ marginTop: "5px", padding: "5px 10px" }}
                          >
                            + Add List Item
                          </button>
                        </div>
                      ) : additionalField.type === "link" ? (
                        <div className="custom-form-group">
                          <label className="custom-label">
                            Social Platform:
                          </label>
                          <select
                            name="linkText"
                            value={additionalField.linkText || ""}
                            onChange={(e) =>
                              handleLinkChange(sectionIndex, fieldIndex, e)
                            }
                            className="custom-input"
                            required
                          >
                            <option value="">Select platform</option>
                            <option value="Instagram">Instagram</option>
                            <option value="Facebook">Facebook</option>
                            <option value="LinkedIn">LinkedIn</option>
                            <option value="Twitter">Twitter</option>
                          </select>
                          <label className="custom-label">Profile URL:</label>
                          <input
                            type="url"
                            name="linkURL"
                            value={additionalField.linkURL || ""}
                            onChange={(e) =>
                              handleLinkChange(sectionIndex, fieldIndex, e)
                            }
                            className="custom-input"
                            required
                            pattern="https?://.+"
                          />
                        </div>
                      ) : additionalField.type === "web-link" ? (
                        <div className="custom-form-group">
                          <label className="custom-label">Link Text:</label>
                          <input
                            type="text"
                            name="webLinkText"
                            value={additionalField.webLinkText || ""}
                            onChange={(e) =>
                              handleLinkChange(sectionIndex, fieldIndex, e)
                            }
                            className="custom-input"
                            required
                          />
                          <label className="custom-label">Link URL:</label>
                          <input
                            type="url"
                            name="webLinkURL"
                            value={additionalField.webLinkURL || ""}
                            onChange={(e) =>
                              handleLinkChange(sectionIndex, fieldIndex, e)
                            }
                            className="custom-input"
                            required
                            pattern="https?://.+"
                          />
                        </div>
                      ) : null}

                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() =>
                          removeAdditionalField(sectionIndex, fieldIndex)
                        }
                        style={{
                          position: "absolute",
                          top: "0",
                          right: "0",
                          background: "transparent",
                          border: "none",
                          color: "red",
                        }}
                      >
                        <FaTimes />
                      </button>
                    </div>
                  ))}

                  {/* Add More Fields Dropdown */}
                  <div className="col-md-12 tagcreator">
                    <div className="custom-form-group">
                      <select
                        className="custom-input"
                        style={{ background: "none", color: "white" }}
                        onChange={(e) => {
                          if (e.target.value) {
                            addAdditionalField(sectionIndex, e.target.value);
                            e.target.value = ""; // Reset the dropdown
                          }
                        }}
                      >
                        <option value="">Creat Content...</option>
                        <option value="paragraph">Add Paragraph</option>
                        <option value="text">Add Text Field</option>
                        <option value="list">Add List</option>
                        <option value="web-link">Add Web Link</option>
                        <option value="link">Add Social Link</option>
                      </select>
                    </div>
                  </div>

                  {/* Delete Button: Positioned at top right of the section */}
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => removeEnergyField(sectionIndex)}
                    style={{
                      position: "absolute",
                      top: "0",
                      right: "0",
                      background: "transparent",
                      border: "none",
                      color: "red",
                    }}
                  >
                    <FaTimes />
                  </button>
                </div>
              ))}

              <button
                type="button"
                className="btn sectioncta mb-4"
                onClick={addFields}
              >
                + Add Section
              </button>
            </div>
          </div>

          <div className="col-md-12">
            <div className="custom-form-group text-right">
              <button
                type="button"
                className="custom-btn-cancel"
                onClick={() => navigate("/bio-data-table")}
              >
                Cancel
              </button>
              <button type="submit" className="custom-btn-submit">
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddBlogForm;
